export const LEADERBOARD_REQUEST = 'LEADERBOARD_REQUEST'
export const LEADERBOARD_SUCCESS = 'LEADERBOARD_SUCCESS'
export const LEADERBOARD_FAIL    = 'LEADERBOARD_FAIL'

export const LIVE_SCORES_REQUEST = 'LIVE_SCORES_REQUEST'
export const LIVE_SCORES_SUCCESS = 'LIVE_SCORES_SUCCESS'
export const LIVE_SCORES_FAIL    = 'LIVE_SCORES_FAIL'
